import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-search',
  imports: [],
  templateUrl: './search.component.html',
  styleUrl: './search.component.scss'
})
export class SearchComponent {
  @Input() placeholder = 'Search...';
  @Output() onSearch = new EventEmitter<string>();

  searchTerm = '';

  initSearch(text: string) {
    this.onSearch.emit(text);
  }
}

